export var FormTypes;
(function (FormTypes) {
  FormTypes[FormTypes["WITH_NAME_AND_NUMBER"] = 0] = "WITH_NAME_AND_NUMBER";
  FormTypes[FormTypes["WITH_EMAIL_AND_ALT_NUMBER"] = 1] = "WITH_EMAIL_AND_ALT_NUMBER";
  FormTypes[FormTypes["ONLY_NUMBER"] = 2] = "ONLY_NUMBER";
  FormTypes[FormTypes["WITH_NUMBER_AND_LANGUAGE"] = 3] = "WITH_NUMBER_AND_LANGUAGE";
  FormTypes[FormTypes["PERSONAL_DETAILS"] = 4] = "PERSONAL_DETAILS";
  FormTypes[FormTypes["WITH_NUMBER_NAME_AND_LANGUAGE"] = 5] = "WITH_NUMBER_NAME_AND_LANGUAGE";
  FormTypes[FormTypes["ONLY_LANGUAGE"] = 6] = "ONLY_LANGUAGE";
  FormTypes[FormTypes["WITH_ALT_NUMBER_AND_EMAIL"] = 7] = "WITH_ALT_NUMBER_AND_EMAIL";
})(FormTypes || (FormTypes = {}));